// extracted by mini-css-extract-plugin
export var orderDetails = "_rn-2";
export var orderImage = "_rn-1";
export var orderMeta = "_rn-3";
export var orderSummary = "_rn-0";
export var rightArrow = "_rn-4";